export const ModuleContext = 'context';
export const ModuleDbOption = 'dbOption';

export const ModuleDialog = 'dialog';
export const ModuleLoading = 'loading';
export const ModuleRegister = 'register';
export const ModulePopup = 'popup';
export const ModuleTickets = 'tickets'
/**
 * Danh sách module của chương trình
 */
export const AppModules = [
  ModuleContext,
  ModuleDbOption,
  ModuleRegister,
];
